module.exports = __webpack_public_path__ + "img/close.dbcb9261.svg";